import courseApi from "@api/course";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import { EmbedLayout } from "@modules/embed";
import { useRouter } from "next/router";
import NotFound from "pages/404";
import { EmbedVideoAccessProvider } from "./embed/EmbedVideoAccessContext";
import EmbeddedVideoPlayer from "./embed/EmbeddedVideoPlayer";
import { FC } from "react";
import VideoEmbeddedSkeleton, {
  parseEmbedPlayerMaxHeight,
} from "@features/video-course/components/embeded-skeleton";

const EmbeddedVideoTemplate: FC = () => {
  const { query } = useRouter();

  const hasValidSlug = Boolean(query?.slug && typeof query.slug === "string");
  const querySlug: string | null = hasValidSlug ? String(query.slug) : null;
  const maxHeight = parseEmbedPlayerMaxHeight(query.height);

  const { data, mutate, error, isValidating } = useRequestImmutable(
    querySlug
      ? courseApi.getCourseData(querySlug, {
          showProduct: 1,
        })
      : null
  );

  if (!querySlug || error) return <NotFound />;
  else if (!data || isValidating)
    return <VideoEmbeddedSkeleton maxHeight={maxHeight} />;

  const showTitle: boolean = !query?.title || query?.title !== "0";
  const fontSize =
    query?.font_size && !isNaN(Number(query.font_size))
      ? Number(query.font_size)
      : 16;

  return (
    <EmbedLayout>
      <EmbedVideoAccessProvider data={data} mutate={mutate}>
        <div className="h-fit">
          {showTitle && (
            <h1 className="m-6" style={{ fontSize: `${fontSize}px` }}>
              {data?.product.title}
            </h1>
          )}
          <EmbeddedVideoPlayer />
        </div>
      </EmbedVideoAccessProvider>
    </EmbedLayout>
  );
};

export default EmbeddedVideoTemplate;
